'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _text = require('./text');

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Text styles for paragraphs (multi line text).
 * This is used in the Paragraph.
 * @property {Object} text.500 - Required property.
 * @property {Object} text.400 - Required property. Default.
 * @property {Object} text.300 - Required property.
 */
exports.default = {
  '500': _extends({}, _text2.default['500'], {
    lineHeight: '24px'
  }),
  '400': _extends({}, _text2.default['400'], {
    lineHeight: '21px'
  }),
  '300': _extends({}, _text2.default['300'], {
    lineHeight: '18px'
  })
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy90aGVtZS9zcmMvZGVmYXVsdC10aGVtZS90eXBvZ3JhcGh5L3BhcmFncmFwaC5qcyJdLCJuYW1lcyI6WyJ0ZXh0IiwibGluZUhlaWdodCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7QUFBQTs7Ozs7O0FBRUE7Ozs7Ozs7a0JBT2U7QUFDYixzQkFDS0EsZUFBSyxLQUFMLENBREw7QUFFRUMsZ0JBQVk7QUFGZCxJQURhO0FBS2Isc0JBQ0tELGVBQUssS0FBTCxDQURMO0FBRUVDLGdCQUFZO0FBRmQsSUFMYTtBQVNiLHNCQUNLRCxlQUFLLEtBQUwsQ0FETDtBQUVFQyxnQkFBWTtBQUZkO0FBVGEsQyIsImZpbGUiOiJwYXJhZ3JhcGguanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdGV4dCBmcm9tICcuL3RleHQnXG5cbi8qKlxuICogVGV4dCBzdHlsZXMgZm9yIHBhcmFncmFwaHMgKG11bHRpIGxpbmUgdGV4dCkuXG4gKiBUaGlzIGlzIHVzZWQgaW4gdGhlIFBhcmFncmFwaC5cbiAqIEBwcm9wZXJ0eSB7T2JqZWN0fSB0ZXh0LjUwMCAtIFJlcXVpcmVkIHByb3BlcnR5LlxuICogQHByb3BlcnR5IHtPYmplY3R9IHRleHQuNDAwIC0gUmVxdWlyZWQgcHJvcGVydHkuIERlZmF1bHQuXG4gKiBAcHJvcGVydHkge09iamVjdH0gdGV4dC4zMDAgLSBSZXF1aXJlZCBwcm9wZXJ0eS5cbiAqL1xuZXhwb3J0IGRlZmF1bHQge1xuICAnNTAwJzoge1xuICAgIC4uLnRleHRbJzUwMCddLFxuICAgIGxpbmVIZWlnaHQ6ICcyNHB4J1xuICB9LFxuICAnNDAwJzoge1xuICAgIC4uLnRleHRbJzQwMCddLFxuICAgIGxpbmVIZWlnaHQ6ICcyMXB4J1xuICB9LFxuICAnMzAwJzoge1xuICAgIC4uLnRleHRbJzMwMCddLFxuICAgIGxpbmVIZWlnaHQ6ICcxOHB4J1xuICB9XG59XG4iXX0=